export const APP_NAME = "Redirect Health";
export const REDIRECT_URL_KEY = "redirectUrl";
